
import Loading from '@/components/chat/loding.vue';
import PostComponent from '@/components/posts/PostComponent.vue';
export default {
  name: 'SectionNotices',
  components: {
    Loading,
    PostComponent,
  },
  props: {
    menuIndex: {
      type: Number,
      default: 1,
    },
    categoryItems: {
      type: Array,
      default: () => [],
    },
    tagColor: {
      type: String,
      default: '#00B0E9',
    },
  },
  computed: {
    styleObject() {
      return {
        '--menu-color': this.tagColor,
      };
    },
    category() {
      return this.categoryItems[this.menuIndex].title;
    },
  },
  data() {
    return {
      loading: false,
      noticeItems: {
        data: [],
        links: {},
        meta: {},
      },
      form: {
        board: 'notices',
        page: 0,
        // district_id: this.$store.state.district.id,
      },
    };
  },
  methods: {
    getNoticeItems() {
      this.form.page = 1;

      this.$axios
        .get('/api/notices', {
          params: this.form,
        })
        .then((response) => {
          this.noticeItems = response.data;
          this.loading = false;
        });
    },
    async loadMore() {
      const { data, meta } = this.noticeItems;
      if (meta.current_page <= meta.last_page) {
        this.form.page = meta.current_page + 1;
        this.$axios
          .get('/api/notices', {
            params: this.form,
          })
          .then((response) => {
            this.noticeItems = {
              data: [...data, ...response.data.data],
              links: response.data.links,
              meta: response.data.meta,
            };
          });
      }
    },
  },
  mounted() {
    this.loading = true;
    // if (!this.$auth.user) {
    //   this.form.district_id = 0;
    // } else if (this.$auth.user) {
    //   this.form.district_id = this.$store.state.district.id;
    // }
    this.getNoticeItems();
  },
};
